module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ddCjB"))).then(() => parcelRequire('f4eak'));